import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { TrendingUp, Menu, X } from "lucide-react";
import { useState } from "react";

export function Logo({ light = false, className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2 ${className}`} data-testid="logo-link">
      <span className="flex h-8 w-8 items-center justify-center rounded-md bg-navy text-white">
        <TrendingUp className="h-5 w-5" />
      </span>
      <span className={`font-heading text-lg font-semibold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
        NetLift
      </span>
    </Link>
  );
}

const NAV = [
  { label: "Product", to: "/" },
  { label: "Integrations", to: "/integrations" },
  { label: "Pricing", to: "/pricing" },
  { label: "Resources", to: "/resources" },
  { label: "Sample dashboard", to: "/demo" },
  { label: "Contact", to: "/contact" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className={`text-sm transition-colors hover:text-slate-900 ${
                location.pathname === n.to ? "text-slate-900 font-medium" : "text-slate-500"
              }`}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <Button variant="ghost" className="text-slate-600" onClick={() => navigate("/login")} data-testid="nav-login-btn">
            Sign in
          </Button>
          <Button className="bg-editorial hover:bg-editorial/90" onClick={() => navigate("/signup")} data-testid="nav-signup-btn">
            Start Free Trial
          </Button>
        </div>
        <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-slate-200 bg-white px-5 py-4 lg:hidden">
          <div className="flex flex-col gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="text-sm text-slate-600" onClick={() => setOpen(false)}>
                {n.label}
              </Link>
            ))}
            <Button variant="outline" onClick={() => navigate("/login")}>Sign in</Button>
            <Button className="bg-editorial hover:bg-editorial/90" onClick={() => navigate("/signup")}>Start Free Trial</Button>
          </div>
        </div>
      )}
    </header>
  );
}
